export const WARNING_TEXT =
  'Нажимая, на кнопку «Подать заявление», вы даете свое согласие на обработку персональных данных.';



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/statement/consts.ts